import { CustomerState } from "../customer.slice.ts";
import { GrossIncomeRequest } from "../../../../orchestrator-api-client";
import { PayloadAction } from "@reduxjs/toolkit";

export const grossIncomeReducer = (
  state: CustomerState,
  action: PayloadAction<GrossIncomeRequest>,
) => {
  state.job.income = {
    ...state.job.income,
    grossAnnualSalary: action.payload.grossAnnualSalary,
  };
};
